"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENotifications = void 0;
var ENotifications;
(function (ENotifications) {
    ENotifications[ENotifications["Unknown"] = 0] = "Unknown";
    ENotifications[ENotifications["ReplacedBet"] = 1] = "ReplacedBet";
    ENotifications[ENotifications["TicketFinished"] = 2] = "TicketFinished";
    ENotifications[ENotifications["SmsCodeSended"] = 3] = "SmsCodeSended";
    ENotifications[ENotifications["ReferralWithdrawSuccess"] = 4] = "ReferralWithdrawSuccess";
    ENotifications[ENotifications["ReferralWithdrawError"] = 5] = "ReferralWithdrawError";
    ENotifications[ENotifications["OperationCanMayAFewMinutes"] = 6] = "OperationCanMayAFewMinutes";
    ENotifications[ENotifications["UserInNotAuthorize"] = 7] = "UserInNotAuthorize";
    ENotifications[ENotifications["LootBoxBetNotFound"] = 8] = "LootBoxBetNotFound";
    ENotifications[ENotifications["AmountIsNotEnough"] = 9] = "AmountIsNotEnough";
    ENotifications[ENotifications["WheelIsNotAvailable"] = 10] = "WheelIsNotAvailable";
    ENotifications[ENotifications["BalanceIsNotAvailable"] = 11] = "BalanceIsNotAvailable";
    ENotifications[ENotifications["PromoCodeError"] = 12] = "PromoCodeError";
    ENotifications[ENotifications["PromoCodeSuccess"] = 13] = "PromoCodeSuccess";
    ENotifications[ENotifications["LootBoxTakeMonthly"] = 14] = "LootBoxTakeMonthly";
    ENotifications[ENotifications["AccrualHistoryError"] = 15] = "AccrualHistoryError";
})(ENotifications || (exports.ENotifications = ENotifications = {}));
